// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
         .popup {
          display: flex;
    flex-direction: column;
    position: absolute;
    gap: 5px;
    /* top: 50%; */
    /* left: 83%; */
    transform: translate(-25%, -50%);
    background: white;
    border: 1px solid black;
    padding: 10px 14px 3px 15px;;
    z-index: 1000;
    border-radius: 8px;
    h3{
      font-size:18px;
      cursor: pointer;
      }
    }

    `, "",{"version":3,"sources":["webpack://./src/app/shared/components/volume-forecasting-custom-popup/volume-forecasting-custom-popup-renderer.component.ts"],"names":[],"mappings":";SACS;UACC,aAAa;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB;MACE,cAAc;MACd,eAAe;MACf;IACF","sourcesContent":["\n         .popup {\n          display: flex;\n    flex-direction: column;\n    position: absolute;\n    gap: 5px;\n    /* top: 50%; */\n    /* left: 83%; */\n    transform: translate(-25%, -50%);\n    background: white;\n    border: 1px solid black;\n    padding: 10px 14px 3px 15px;;\n    z-index: 1000;\n    border-radius: 8px;\n    h3{\n      font-size:18px;\n      cursor: pointer;\n      }\n    }\n\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
